import type { ReactNode } from 'react'

import { Banner } from '@/components/ui/banner'
import { useFeatureFlag } from '@/models/flag'

export const POLICY_CHANGES_FLAG = 'ENABLE_ENDORSEMENTS'

/** The pages stay closed while the org's flag is off, so a typed URL can't outrun the switch. */
export function PolicyChangesGate({ children }: { children: ReactNode }) {
  const open = useFeatureFlag(POLICY_CHANGES_FLAG)
  if (!open) return <Banner variant="info">Policy changes aren't open for your business yet.</Banner>
  return <>{children}</>
}
